import { useState } from 'react';
import { Resource } from '@domain/base/Resource';
import { container } from '@infrastructure/container';
import { useQuery } from '@tanstack/react-query';

import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useConnections = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const queryClient = useQueryClient();

    const { data: connections } = useQuery({
        queryKey: ['connections'],
        queryFn: async () => {
            const connections = await container.marketplaceRepository.fetchConnections();
            if (connections.status === 'success') {
                return connections.data;
            }
            return [];
        }
    });

    const { data: connectors } = useQuery({
        queryKey: ['connectors'],
        queryFn: async () => {
            const connectors = await container.marketplaceRepository.fetchConnectors();
            if (connectors.status === 'success') {
                return connectors.data;
            }
            return [];
        }
    });

    const removeConnectionMutation = useMutation<Resource<void>, unknown, string>({
        mutationFn: async (connectionId: string) => {
            setIsLoading(true);
            setError(null);
            try {
                const response = await container.marketplaceRepository.removeConnection(connectionId);
                return response;
            } catch (err) {
                const errorResponse = {
                    status: 'error' as const,
                    error: {
                        type: 'UnknownError' as const,
                        message: err instanceof Error ? err.message : 'Failed to remove connection'
                    }
                };
                setError(errorResponse.error.message);
                return errorResponse;
            } finally {
                setIsLoading(false);
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['connections'] });
        },
        onError: () => {
            queryClient.invalidateQueries({ queryKey: ['connections'] });
        }
    });


    return {
        connections,
        connectors,
        isLoading,
        error,
        removeConnection: removeConnectionMutation.mutateAsync
    };
}; 